export type BusinessType = 'retail' | 'coffee_shop' | 'restaurant' | 'semi_manufacture' | 'manufacture';

export const BUSINESS_TYPES: { value: BusinessType; label: string; description: string }[] = [
  { value: 'retail', label: 'Toko Retail', description: 'Toko kelontong, minimarket, toko baju' },
  { value: 'coffee_shop', label: 'Kedai Kopi', description: 'Kafe, coffee shop, juice bar' },
  { value: 'restaurant', label: 'Restoran', description: 'Restoran, warung makan, food court' },
  { value: 'semi_manufacture', label: 'Manufaktur Semi', description: 'Roti, kue, kerajinan tangan' },
  { value: 'manufacture', label: 'Manufaktur', description: 'Pabrik, produksi skala besar' },
];
